import { CenteringDiv, FlexRowDiv, H1 } from 'components/generic/HomePageComponents'
import ValuePropCard from './ValuePropCard'

const ValueProp = ({ helpingHeader, helping1, helping2, helping3, helping4 }) => (
  <FlexRowDiv>
    <CenteringDiv maxWidth='1259px'>
      <H1
        fontSize={{ _: '30px', tablet: '40px', desktop: '50px' }}
        maxWidth='700px'
        textAlign='center'
        lineHeight='1.1'
      >
        {helpingHeader}
      </H1>
      <CenteringDiv
        justifyContent='space-around'
        flexWrap='wrap'
        display='flex'
        flexDirection='row'
      >
        <ValuePropCard item={helping1} />
        <ValuePropCard item={helping2} />
        <ValuePropCard item={helping3} />
        <ValuePropCard item={helping4} />
      </CenteringDiv>
    </CenteringDiv>
  </FlexRowDiv>
)

export default ValueProp
